import { Workflow, AppWindow, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { site } from "../content/site";

const icons = { workflow: Workflow, app: AppWindow, shield: ShieldCheck };

const Field = ({ label, text }) => (
  <div>
    <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-teal-700">{label}</p>
    <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{text}</p>
  </div>
);

export const Solutions = () => {
  const [first, second, third] = site.solutions.items;

  const cardClass =
    "group bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 transition-all duration-300 hover:border-teal-500/40 hover:shadow-[0_16px_50px_-20px_rgba(13,148,136,0.3)] hover:-translate-y-1";

  const CardHead = ({ item }) => {
    const Icon = icons[item.icon];
    return (
      <div className="flex items-start gap-4">
        <span className="shrink-0 w-11 h-11 rounded-xl bg-teal-50 border border-teal-200/60 text-teal-600 flex items-center justify-center transition-colors duration-300 group-hover:bg-teal-600 group-hover:text-white">
          <Icon size={20} strokeWidth={2} />
        </span>
        <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-slate-900 pt-1.5">
          {item.title}
        </h3>
      </div>
    );
  };

  return (
    <section id="solutions" data-testid="solutions-section" className="py-20 lg:py-28 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-teal-700 bg-teal-50 border border-teal-200/60 px-3 py-1.5 rounded-full inline-block">
            {site.solutions.eyebrow}
          </p>
          <h2 className="mt-6 font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            {site.solutions.heading}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">{site.solutions.sub}</p>
        </Reveal>

        <div className="mt-12 grid grid-cols-12 gap-5 lg:gap-6">
          <Reveal className="col-span-12 md:col-span-7" delay={0.05}>
            <article data-testid={first.testId} className={`${cardClass} h-full flex flex-col`}>
              <CardHead item={first} />
              <div className="mt-7 grid sm:grid-cols-3 gap-6 flex-1">
                <Field label="Problem" text={first.problem} />
                <Field label="Solution" text={first.solution} />
                <Field label="Your benefit" text={first.benefit} />
              </div>
            </article>
          </Reveal>

          <Reveal className="col-span-12 md:col-span-5" delay={0.12}>
            <article data-testid={second.testId} className={`${cardClass} h-full flex flex-col`}>
              <CardHead item={second} />
              <div className="mt-7 flex flex-col gap-6 flex-1">
                <Field label="Problem" text={second.problem} />
                <Field label="Solution" text={second.solution} />
                <Field label="Your benefit" text={second.benefit} />
              </div>
            </article>
          </Reveal>

          <Reveal className="col-span-12" delay={0.18}>
            <article data-testid={third.testId} className={`${cardClass} grid md:grid-cols-12 gap-8 items-start`}>
              <div className="md:col-span-4">
                <CardHead item={third} />
              </div>
              <div className="md:col-span-8 grid sm:grid-cols-3 gap-6">
                <Field label="Problem" text={third.problem} />
                <Field label="Solution" text={third.solution} />
                <Field label="Your benefit" text={third.benefit} />
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
